import React from "react";

import { LinkButton } from "../../components";

export const CTASimple = ({ title, description, button }) => {
  return (
    <div className="bg-gray-50">
      <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
        {title && <h2 className="text-3xl font-bold text-blue-500">{title}</h2>}
        {description && (
          <p className="mt-6 text-lg leading-6 text-gray-600">{description}</p>
        )}
        {button && (
          <div className="max-w-xs mx-auto mt-6">
            <LinkButton shadow arrow size="large" to={button.url}>
              {button.text}
            </LinkButton>
          </div>
        )}
      </div>
    </div>
  );
};
